export const HUMAN_ROLE_IDS = ['manager_pactlane', 'manager_agency_creator', 'creator_talent', 'brand'] as const
export type HumanRoleId = typeof HUMAN_ROLE_IDS[number]

export type StudioUser = {
  userId: string
  username: string | null
  displayName: string | null
  legacyRole: string
  humanRoleId: HumanRoleId | null
  rolePresetVersion: number | null
  membershipStatus: string
  defaultView: string | null
  hasUserOverride: boolean
  enabledModules: string[]
}

export type RolePresetOption = {
  roleId: HumanRoleId
  version: number
  capabilities: string[]
}

export type StudioRoleDiff = {
  changed: boolean
  before: { roleId: HumanRoleId | null; presetVersion: number | null }
  after: { roleId: HumanRoleId; presetVersion: number }
}

export function normalizeStudioQuery(query: string): string {
  return query.trim().slice(0, 120)
}

export function buildRoleDiff(user: Pick<StudioUser, 'humanRoleId' | 'rolePresetVersion'>, roleId: HumanRoleId, presetVersion: number): StudioRoleDiff {
  if (!HUMAN_ROLE_IDS.includes(roleId)) throw new Error('invalid role id')
  if (!Number.isInteger(presetVersion) || presetVersion < 1) throw new Error('invalid preset version')
  return {
    changed: user.humanRoleId !== roleId || user.rolePresetVersion !== presetVersion,
    before: { roleId: user.humanRoleId, presetVersion: user.rolePresetVersion },
    after: { roleId, presetVersion },
  }
}

export function validateCustomizationReason(reason: string): string {
  const normalized = reason.trim()
  if (normalized.length < 3 || normalized.length > 1000) throw new Error('reason must contain 3-1000 characters')
  return normalized
}

export function createCorrelationId(prefix = 'studio'): string {
  const random = Math.random().toString(36).slice(2, 10)
  return `${prefix}-${Date.now()}-${random}`
}
